global.isMapboxglSupported = require('@mapbox/mapbox-gl-supported');
global.mapboxgl = require('mapbox-gl/dist/mapbox-gl');
global.MapboxDirections = require('@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions');
